<template>
  <div class="dataset-table-box">
    <div class="header-box">
      <div class="tip-box">
        <div
          class="public-tips-primary"
          v-if="isTipVisible()">
          注：列表中只显示已转换成功的数据集
        </div>
      </div>
      <div class="common-input-box">
        <el-input
          class="input-primary"
          size="small"
          placeholder="请输入名称搜索"
          v-model="name"
          clearable
          @clear="search"
          @keyup.enter.native="search">
          <i
            slot="suffix"
            class="el-input__icon el-icon-search"
            @click="search" />
        </el-input>
      </div>
    </div>
    <div
      class="common-table-box"
      v-if="!loading">
      <el-table
        highlight-selection-row
        height="100%"
        class="publish-table"
        row-key="id"
        :data="dataSetList"
        @select="selectChange"
        @select-all="selectChange">
        <el-table-column
          type="selection"
          width="60" />
        <el-table-column
          label="序号"
          type="index"
          width="55" />
        <el-table-column label="数据集名称">
          <template v-slot="{ row }">
            <div
              class="text-overflow"
              :title="row.name">
              {{ row.name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="数据集大小"
          v-if="!schemeType.includes('Wmts')">
          <template v-slot="{ row }">
            <div>
              {{
                `${formatFileSize(row.size).fileSize}${
                  formatFileSize(row.size).unit
                }`
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="总构件数/个"
          v-if="schemeType.includes('Model')">
          <template v-slot="{ row }">
            <div>
              {{ row.componentsCount }}
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="三角面数/个"
          v-if="schemeType.includes('Model')"
        >
          <template v-slot="{ row }">
            <div>
              {{ row.trianglesCount }}
            </div>
          </template>
        </el-table-column> -->
        <el-table-column label="创建时间">
          <template v-slot="{ row }">
            <div>
              {{ formatTime(row.creationTime) }}
            </div>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="common-empty-box">
            <bj-empty
              :image="require('@/assets/img/no-data.png')"
              class="empty-page">
              <template slot="description">
                <div class="empty-text">抱歉，没有找到相关内容</div>
              </template>
            </bj-empty>
          </div>
        </template>
      </el-table>
      <div class="common-pagination-box">
        <el-pagination
          class="pagination-primary"
          popper-class="common-pagination-popper-box"
          layout="sizes, prev, pager, next, jumper"
          :page-sizes="[10, 20, 50, 100, 150, 200]"
          :page-size="pageSize"
          :current-page="currPage"
          :total="total"
          @size-change="pageSizeChange"
          @current-change="pageChange" />
      </div>
    </div>
  </div>
</template>

<script>
import { formatFileSize, formatTime } from '@/utils/generalMethods'

import { getOfflineDataSetSelectListService } from '@/service/interface'

export default {
  data() {
    return {
      loading: false,
      dataSetList: [],
      selectDataSets: [],

      name: '',
      currPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  props: {
    projId: String,
    schemeType: String
  },
  methods: {
    updateDataSetList() {
      this.queryDataSetList().then(dataSetList => {
        this.dataSetList = dataSetList
      })
    },
    search() {
      this.currPage = 1
      this.updateDataSetList()
    },
    pageChange(currPage) {
      this.currPage = currPage
      this.updateDataSetList()
    },
    pageSizeChange(pageSize) {
      this.currPage = 1
      this.pageSize = pageSize
      this.updateDataSetList()
    },
    selectChange(dataSets) {
      this.selectDataSets = dataSets
    },
    getSelectDataSets() {
      return this.selectDataSets
    },
    queryDataSetList() {
      return new Promise(resolve => {
        if (!this.projId) {
          this.total = 0
          resolve([])
          return
        }

        let scheme = ''
        if (this.schemeType.includes('Model')) {
          scheme = 'Bim'
        } else {
          scheme = this.schemeType
        }
        let isModelSet = this.schemeType.includes('ModelGroup') ? true : false
        let params = {
          resultCount: this.pageSize,
          skipCount: (this.currPage - 1) * this.pageSize,
          projId: this.projId,
          name: this.name,
          scheme,
          isModelSet
        }
        getOfflineDataSetSelectListService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let dataSetList = data.items
            this.total = data.totalCount
            resolve(dataSetList)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    isTipVisible() {
      const hiddenSchemeType = ['Rs', 'Wmts', 'Osgb']
      return !hiddenSchemeType.includes(this.schemeType)
    },
    formatFileSize,
    formatTime
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.dataset-table-box {
  height: 100%;

  .header-box {
    display: flex;
    justify-content: space-between;
    line-height: 32px;

    // .tip-box {
    //   font-size: 12px;
    //   color: rgba(255, 255, 255, 0.8);
    // }
  }

  .common-table-box {
    margin-top: 16px;
    height: calc(100% - 48px);

    .publish-table {
      height: calc(100% - 66px) !important;
    }

    .common-pagination-box {
      text-align: center;

      .pagination-primary {
        margin-left: 0;
        margin-right: 0;
        background: transparent;
        box-shadow: none;
      }
    }
  }
}
</style>
